import React, { Component } from 'react'

// lib
import classnames from 'classnames'

import { withStyles } from '@material-ui/core'
// redux
import { connect } from 'react-redux'
import { compose, bindActionCreators } from 'redux'
import actions from '../../redux/language/actions'
import organizationActions from '../../redux/organization/actions'
import userAction from '../../redux/user/actions'
// antd
import { FaPlusCircle } from 'react-icons/fa'
import Button from '../../components/uielements/button'
import { Input, Modal } from 'antd'

import Grid from '@material-ui/core/Grid'
// subcomponent
import BreadCrumb from './breadcrumb'

//component Helper
import ModalOrganiztion from './ModalAddOrgani'
import ModalUsers from './ModalUsers/index'
import ModalInfoOrgani from './ModalInfoOrgani'
import ModalUserInfo from './ShowListUser/modal_user_info'

import Container from '@material-ui/core/Container'
import ItemOrgani from './ItemOrgani'
import styles from './styles'

const { Search } = Input

class OriganizationManagement extends Component {
    constructor(props) {
        super(props)
        this.state = {
            visible: false,
            roleUser: {
                addOrganiRole: false,
                editOrgnaiRole: false,
                deleteOrganiRole: false,
                viewOrganiRole: false,
            },
        }
    }

    componentDidMount() {
        const loadType = organizationActions.loadType.GET_NOT_DELETED
        this.props.loadListOrganizations(loadType)

        if (this.props.userInfo.tier_id === 100) {
            //QTHT
            const { modalActionCreators } = this.props
            const { getListActionById } = modalActionCreators

            getListActionById(0)
        } else {
            const roleId = this.props.userInfo.roles[0]
            const { modalActionCreators } = this.props
            const { getListActionById } = modalActionCreators

            getListActionById(roleId)
        }
        console.log('get current org', this.props.match.params.id)
        if (this.props.match.params.id) {
            console.log('get current org', this.props.match.params.id)
            this.props.getOrgById([this.props.match.params.id])
        }
    }

    _onAddOrganiClick = () => {
        const { modalActionCreators } = this.props
        const { showModal, changeModalTitle } = modalActionCreators
        const { preAddOrgani } = modalActionCreators
        // setOrganizationEditing(null);
        preAddOrgani()
        showModal()
        changeModalTitle('Thêm Mới Cơ Quan', 'Thêm Mới')
    }

    _handleEditOrganization = organization => {
        const { modalActionCreators } = this.props
        const { updateCurrentOrganization } = modalActionCreators
        const {
            getListBoss,
            getListDeputy,
            getListMember,
        } = modalActionCreators
        if (organization.boss_id > 0) {
            let boss_ids = [organization.boss_id]
            getListBoss(boss_ids)
        } else {
            getListBoss([])
        }

        if (organization.deputy_id.length !== 0) {
            let deputy_id = organization.deputy_id
            getListDeputy(deputy_id)
        } else {
            getListDeputy([])
        }

        if (organization.member_ids.length !== 0) {
            let member_ids = organization.member_ids
            getListMember(member_ids)
        } else {
            getListMember([])
        }
        //console.log(" _handleEditOrganization organization: ", organization)
        updateCurrentOrganization(organization)

        // setOrganizationEditing(organization);
        const { showModal, changeModalTitle } = modalActionCreators
        showModal()
        changeModalTitle('Thay Đổi Cơ Quan', 'Lưu Lại')
    }
    componentWillReceiveProps(nextprops) {
        if (nextprops.orgGetById !== this.props.orgGetById) {
            this._handleInfoOrganization(nextprops.orgGetById)
        }
    }

    _handleDeleteOrganization = organization => {
        const { confirm } = Modal
        const { modalActionCreators } = this.props
        const { removeOrganization } = modalActionCreators

        confirm({
            title: 'Bạn chắc chắn muốn xóa ' + `${organization.name}`,
            okText: 'Yes',
            okType: 'danger',
            cancelText: 'No',
            onOk() {
                removeOrganization(organization.oid)
            },
            onCancel() {
                console.log('Cancel')
            },
        })
    }

    _handleInfoOrganization = organization => {
        const { modalActionCreators } = this.props
        const { showModalInfo, updateCurrentOrganization } = modalActionCreators
        console.log('organization:123 ', organization)

        //for Modal Info Organi:
        let array = [0]
        let boss_id = organization.boss_id
        let deputy_id = organization.deputy_id
        let member_ids = organization.member_ids

        if (boss_id) array.push(boss_id)
        if (deputy_id.length > 0) array = array.concat(deputy_id)
        if (member_ids.length > 0) array = array.concat(member_ids)

        const { getListUserInOrgani } = modalActionCreators

        getListUserInOrgani(array)
        updateCurrentOrganization(organization)
        showModalInfo()
    }

    _renderListOrganiztion(organizations) {
        const { classes } = this.props
        let xhtml = null
        //onClickEdit, organization, onClickDelete,onListDeputy,onListMember
        xhtml = (
            <Container>
                <Grid container spacing={6}>
                    {organizations.map((organization, index) => (
                        <Grid item key={index} xs={12} sm={6} md={3}>
                            <ItemOrgani
                                key={index}
                                organization={organization}
                                //listAllUser = {listAllUser}
                                onClickEdit={() =>
                                    this._handleEditOrganization(organization)
                                }
                                onClickDelete={() =>
                                    this._handleDeleteOrganization(organization)
                                }
                                onClickInfo={() =>
                                    this._handleInfoOrganization(organization)
                                }
                            />
                        </Grid>
                    ))}
                </Grid>
            </Container>
        )
        return xhtml
    }

    getNameByOid = () => {}

    render() {
        let { organizations } = this.props
        const createRole = this.props.roleOfUserInOrgani.createOrgani
        return (
            <div className="OrganizationMain">
                <div className="Card">
                    <div className={classnames('row', 'HeaderBar')}>
                        <div>
                            {createRole && (
                                <Button
                                    type="primary"
                                    onClick={this._onAddOrganiClick}
                                >
                                    <FaPlusCircle className="iconButton" />
                                    Thêm đơn vị
                                </Button>
                            )}
                        </div>
                    </div>
                    {this._renderListOrganiztion(organizations)}
                    <ModalOrganiztion />
                    <ModalUsers />
                    <ModalUserInfo />
                    <ModalInfoOrgani />
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        organizations: state.organization.organizations,
        roleOfUserInOrgani: state.organization.roleOfUserInOrgani,
        orgGetById: state.organization.orgGetById,
        roles: state.organization.roles,
        listAllUser: state.user.users,
        userInfo: state.auth.userInfo,
        ...state.app,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        loadListOrganizations: loadType => {
            dispatch(organizationActions.action.loadListOrganization(loadType))
            //dispatch(organizationActions.action.getListRole())
            dispatch(userAction.action.getListRole())

        },
        getOrgById: lst => {
            dispatch(organizationActions.action.getOrgById(lst))
        },
        modalActionCreators: bindActionCreators(
            organizationActions.action,
            dispatch
        ),
    }
}

const withConnect = connect(
    mapStateToProps,
    mapDispatchToProps
)

export default compose(
    withConnect,
    withStyles(styles)
)(OriganizationManagement)
